export const PATREON_TIER_LOOKUP: Record<string, number> = {
  '2781497': 1, // No Strings Attached
  '4417146': 2, // For Casual Villagers
  '2757429': 3, // For Resident Representatives
  '2783249': 4, // For Tom Nooks
  '4416635': 5, // For Tom Nooks' Favorite Villagers
}
